// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JpHE","largestCol":"styles_largestCol__29a8e","smallestCol":"styles_smallestCol__1R-YA"};